import "~/js/modules/stickyNav";
import '~/js/modules/section-hero';
import 'slick-carousel';
import GoFetch from '~/js/modules/fetch-wrapper.js';
const fetch = new GoFetch();
setTimeout(() => {
  const newAccommodationsSlider = $('.js-bng-accommodations-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    prevArrow: '<button aria-label="Previous" class="prev resort-slider-arrow"><i class="icon icon-button-arrow-prev"></i></button>',
    nextArrow: '<button aria-label="Next" class="next resort-slider-arrow"><i class="icon icon-button-arrow-next"></i></button>'
  });
  newAccommodationsSlider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    const nextImg = slick.$slides[nextSlide];
    const srcImg = nextImg.dataset.src;
    nextImg.src = srcImg;
    nextImg.addEventListener('load', () => {
      nextImg.style.opacity = 1;
    });
  });
}, "1000");

const queryString = window.location.search;
if (queryString !== '') {
  const urlParams = new URLSearchParams(queryString);
  const videoID = urlParams.get('video');
  document.getElementById(videoID).click();
}

// Sliders